import React, { Component, Fragment } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import PropTypes from 'prop-types'
import MyButton from '../../util/MyButton'

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import DeleteOutline from '@material-ui/icons/DeleteOutline'

import { connect } from 'react-redux'
import { deleteOpinion } from '../../redux/actions/dataActions'

const styles = {
    deleteOpinion: {
        top: '10%',
        left: '90%',
        position: 'absolute'
    }
}

class DeleteOpinion extends Component {
    state = {
        open: false
    };
    handleOpen = () => {
        this.setState({open:true})
    }
    handleClose = () => {
        this.setState({open:false})
    }
    deleteOpinion = () => {
        this.props.deleteOpinion(this.props.wreckID);
        this.setState({open:false})
    }
    render() {
        const { classes } = this.props;
        return (
            <Fragment>
                <MyButton tip='Remove Opinion' onClick={this.handleOpen} btnClassName={classes.deleteOpinion}>
                    <DeleteOutline color='secondary' />
                </MyButton>
                <Dialog open={this.state.open} onClose={this.handleClose} maxWidth='sm'>
                    <DialogTitle>
                        Are you sure you want to remove your opinion?
                    </DialogTitle>
                    <DialogActions>
                        <Button onClick={this.handleClose} color='primary'>
                            Cancel
                        </Button>
                        <Button onClick={this.deleteOpinion} color='secondary'>
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>
            </Fragment>
        )
    }
}

DeleteOpinion.propTypes = {
    deleteOpinion: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
    wreckID: PropTypes.string.isRequired
}

export default connect(null, {deleteOpinion})(withStyles(styles)(DeleteOpinion))
